import type { Theme, ThemeFamilyId } from './contract.js';
import { defaultTheme } from './themes/default/index.js';
import { luceTheme } from './themes/luce/index.js';
import { cartographicTheme } from './themes/cartographic/index.js';
// Driver Themes ticket — 4 net-new families (2 net-new themes plus
// 2 promotions from skin overlays). Registered alongside the
// existing 3 families; THEME_ORDER below sets picker display order.
import { neonTheme } from './themes/neon/index.js';
import { electricLightTheme } from './themes/electric-light/index.js';
import { darkElectricTheme } from './themes/dark-electric/index.js';
import { obsidianTheme } from './themes/obsidian/index.js';
// Post unlock-model rewrite — milestone-locked theme families.
// Aurora @ 850 kWh + Cyber @ 1150 kWh ship with their own
// shader builds. Both registered alongside the existing 7
// families; THEME_ORDER below sets picker display order.
import { auroraTheme } from './themes/aurora/index.js';
import { cyberTheme } from './themes/cyber/index.js';

export const THEMES: Record<ThemeFamilyId, Theme> = {
  default: defaultTheme,
  luce: luceTheme,
  cartographic: cartographicTheme,
  neon: neonTheme,
  'electric-light': electricLightTheme,
  'dark-electric': darkElectricTheme,
  obsidian: obsidianTheme,
  aurora: auroraTheme,
  cyber: cyberTheme,
};

/** Picker display order. Driver Themes ticket put the shader
 *  families up front. Milestone-gated themes (aurora @ 850 kWh,
 *  cyber @ 1150 kWh) slot in after the always-owned shader
 *  families and in milestone-threshold order so the picker
 *  surfaces achievable themes first and the elite/locked tier
 *  last. Luce + Cartographic stay at the back as specialty /
 *  CSS-driven options. */
export const THEME_ORDER: ThemeFamilyId[] = [
  'default',
  'neon',
  'electric-light',
  'dark-electric',
  'obsidian',
  'aurora',
  'cyber',
  'luce',
  'cartographic',
];

export function getTheme(id: ThemeFamilyId | null | undefined): Theme {
  if (!id || !(id in THEMES)) return defaultTheme;
  return THEMES[id];
}

export function listThemes(): Theme[] {
  return THEME_ORDER.map((id) => THEMES[id]);
}
